import React from 'react';
import { TextAreaFieldTW } from '../../../../../../tailwindComponents/textAreaTW/TextAreaFieldTW';
import { Show } from '../../../../../shared/Show';
import { BodyTextTW } from '../../../../../../tailwindComponents/bodyText/BodyTextTW';
import { useFormikContext } from 'formik';
import { hasNotesStep } from '../../03_methodsStep/MethodStep';
import { IDetailsFormData } from './types/IDetailsFormData';
import { isNil } from 'lodash';

export const NotesSection: React.FC = () => {
  const { values } = useFormikContext<IDetailsFormData>();
  return (
    <Show when={!hasNotesStep(values.signingMethod, !!values.signerWillProvideLocation)}>
      <TextAreaFieldTW labelText={'Internal Notes'} name={'notes'} maxLength={250} />
      <Show when={!isNil(values.notes)}>
        <BodyTextTW className={'text-red-800'}>Characters remaining: {250 - (values.notes?.length ?? 0)}</BodyTextTW>
      </Show>
    </Show>
  );
};
